export default {
  state: {
    statusBarH: 20,
    navigationBarH: 44,
    homeKeyH: 0,
    isFirstRouter: false
  },
  mutations: {
    setStatusBarHeight(state, height) {
      state.statusBarH = height
    },
    setNavigationBarHeight(state, height) {
      state.navigationBarH = height
    },
    setHomeKeyHeight(state, height) {
      state.homeKeyH = height
    },
    setIsFirstRouter(state, isFirstRouter) {
      state.isFirstRouter = isFirstRouter
    }
  },
  getters: {
    getStatusBarH: state => {
      return state.statusBarH
    },
    getNavigationBarH: state => {
      return state.navigationBarH
    },
    getHomeKeyH: state => {
      return state.homeKeyH
    },
    getIsFirstRouter: state => {
      return state.isFirstRouter
    }
  },
  actions: {
    setStatusBarHeight({ commit }, height) {
      commit('setStatusBarHeight', height)
    },
    setNavigationBarHeight({ commit }, height) {
      commit('setNavigationBarHeight', height)
    },
    setHomeKeyHeight({ commit }, height) {
      commit('setHomeKeyHeight', height)
    },
    setIsFirstRouter({ commit }, isFirstRouter) {
      commit('setIsFirstRouter', isFirstRouter)
    }
  }
}
